import { sendAnalytics } from '../analytics/tracker';
import manageTracking from '../analytics/creators/manage';

function sendRecoverPinPasswordMetric({ dispatch, type }) {
  dispatch(sendAnalytics({
    eventCreator: manageTracking.trackRecoverPinPassword(type),
  }));
}

export {
  sendRecoverPinPasswordMetric,
};